<section role="main">
  <form #form="ngForm" (submit)="onSubmit(form.valid)" validateOnSubmit id="login-form" class="form-signin" role="form">
    <h2 class="form-signin-heading">Prefeitura Municipal de Vitória</h2>
    <div class="form-signin" role="form">
      <div [ngClass]="{'has-error': error}" class="form-group username">
        <pmv-input-text [(ngModel)]="authenticationData.username" name="username"
          placeholder="Usuário"
        ></pmv-input-text>
      </div>
      <div [ngClass]="{'has-error': error}" class="form-group password">
        <pmv-input-text [(ngModel)]="authenticationData.password" name="password"
          placeholder="Senha" type="password"
        ></pmv-input-text>
      </div>
      <button class="btn btn-lg btn-primary btn-block" type="submit" style="position: relative" [disabled]="authenticating">
        <span class="fa fa-spinner fa-spin pull-left" style="position: absolute; left: 13px; top: 13px;" *ngIf="authenticating"></span>
        Autenticar
      </button>
    </div>
  </form>
</section>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.PMVAuthenticationComponent.html